import { workSheetConstants } from '../../_constants';

const initialState = { getWorksheetLoading: true, data: '', error: false };

export function getWorksheetReducer(state = initialState, action) {
    
    switch (action.type) {
        case workSheetConstants.REQUEST_GET_WORKSHEET:
            return {
                getWorksheetLoading: true,
                data: '',
                error: false
            };
        case workSheetConstants.RECEIVE_GET_WORKSHEET:
            return {
                getWorksheetLoading: false,
                data: action.getWorksheet,
                error: false
            };
        case workSheetConstants.GET_WORKSHEET_ERROR:
            return {
                getWorksheetLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/workSheet/getWorkSheets.reducer.js